module.exports = __webpack_public_path__ + "img/architecture-01.d8f80b45.svg";